<template>
    <div id="app">
        <q-layout view="hHh lpR fFf">

            <q-header v-if="isAnonymous != true" bordered :class="dataMode == 1 ? 'test bg-primary text-white' : 'bg-primary text-white'"
                      class="bg-primary text-white">
                <q-toolbar>
                    <q-btn flat round dense icon="menu" class="q-mr-sm" @click="showMenu = !showMenu"></q-btn>
                    <q-separator dark vertical inset></q-separator>
                    <q-toolbar-title>
                        Customer Portal
                    </q-toolbar-title>

                    <q-space></q-space>

                    <q-btn-dropdown stretch flat :label="dataModeTitle">
                        <q-list>
                            <q-item v-if="dataMode == 0" clickable v-close-popup v-ripple @click="switchToTestMode">
                                <q-item-section>Switch to Dev</q-item-section>
                            </q-item>
                            <q-item v-if="dataMode == 1" clickable v-close-popup v-ripple @click="switchToProdMode">
                                <q-item-section>Switch to Prod</q-item-section>
                            </q-item>
                        </q-list>
                    </q-btn-dropdown>

                    <q-separator dark vertical></q-separator>
                    <q-btn v-if="availableCustomers.length <= 1" stretch flat :label="customerName"></q-btn>
                    <q-btn-dropdown v-if="availableCustomers.length > 1" stretch flat :label="customerName">
                        <q-list>
                            <template v-for="(customer, indexCustomer) in availableCustomers">
                                <q-item clickable v-close-popup v-ripple @click="switchCustomer(customer.Key)">
                                    <q-item-section>{{ customer.Name }}</q-item-section>
                                </q-item>
                            </template>
                        </q-list>
                    </q-btn-dropdown>

                    <q-separator dark vertical></q-separator>
                    <q-btn-dropdown stretch flat :label="userName">
                        <q-list>
                            <q-item clickable v-close-popup v-ripple @click="profile">
                                <q-item-section>Profile</q-item-section>
                            </q-item>
                            <q-item v-show="!isFederated" clickable v-close-popup v-ripple @click="resetPassword">
                                <q-item-section>Reset Password</q-item-section>
                            </q-item>
                            <q-item v-show="!isFederated" clickable v-close-popup v-ripple @click="editMFASettings">
                                <q-item-section>MFA Settings</q-item-section>
                            </q-item>
                        </q-list>
                    </q-btn-dropdown>

                    <q-btn flat round dense icon="logout" @click="logout">
                    </q-btn>
                </q-toolbar>
            </q-header>

            <q-drawer show-if-above v-model="showMenu" side="left" bordered>
                <q-scroll-area class="fit">
                    <q-list dense>
                        <template v-for="(menuItemGroup, indexGroup) in menuItemGroups">
                            <q-expansion-item group="categories" :key="'group' + indexGroup" :icon="menuItemGroup.icon" :label="menuItemGroup.title">
                                <template v-for="(menuItem, indexItem) in menuItemGroup.items">
                                    <q-expansion-item :group="'category' + indexGroup" v-if="menuItem.items != null" :key="'item' + indexItem" :label="menuItem.title" :header-inset-level="0.1" :content-inset-level="0.2">
                                        <template v-for="(categoryItem, indexCategoryItem) in menuItem.items">
                                            <q-expansion-item :group="'category' + indexGroup + 'app' + indexItem" v-if="categoryItem.items != null" :key="'categoryItem' + indexCategoryItem" :label="categoryItem.title" :header-inset-level="0.1">
                                                <template v-for="(tradingPartnerItem, indexTradingPartnerItem) in categoryItem.items">
                                                    <q-item :key="'tradingPartnerItem' + indexTradingPartnerItem" class="q-ml-md" clickable v-ripple :to="tradingPartnerItem.path" :label="tradingPartnerItem.title">
                                                        <q-item-section>
                                                            {{ tradingPartnerItem.title }}
                                                        </q-item-section>
                                                    </q-item>
                                                </template>
                                            </q-expansion-item>
                                            <q-item v-if="categoryItem.items == null" :key="'categoryItem' + indexItem" class="q-ml-md" clickable v-ripple :to="categoryItem.path" :label="categoryItem.title">
                                                <q-item-section>
                                                    {{ categoryItem.title }}
                                                </q-item-section>
                                            </q-item>
                                        </template>
                                    </q-expansion-item>

                                    <q-item v-if="menuItem.items == null" :key="'item' + indexItem" class="q-ml-md q-single-item" clickable v-ripple :to="menuItem.path">
                                        <q-item-section>
                                            {{ menuItem.title }}
                                        </q-item-section>
                                    </q-item>
                                </template>
                            </q-expansion-item>
                        </template>
                    </q-list>
                </q-scroll-area>
            </q-drawer>

            <q-page-container v-if="isAnonymous != true">
                <router-view />
            </q-page-container>

            <q-page-container v-if="isAnonymous">
                <home :showLoginAction="isAnonymous"></home>
            </q-page-container>

        </q-layout>
    </div>
</template>

<style>
    .q-single-item {
        margin-left: 5px !important;
    }

    .test.bg-primary {
        background: #570000 !important;
    }
</style>

<script>
    import Home from './screens/custom/home-custom-screen.vue';
    import CurrentUserEditModel from './screens/currentusereditmodel-dialog-screen.vue';
    import MFASettingsEditModel from './screens/custom/mfasettingseditmodel-dialog-screen.vue';

    export default {
        components: {
            'home': Home
        },

        data() {
            return {
                showMenu: false,
                menuItemGroups: [],
                availableCustomers: [],
                customerName: '',
                userName: '',
                isFederated: false,
                isAdmin: false,
                isAnonymous: true,
                dataMode: false
            }
        },

        computed: {
            dataModeTitle: function () {
                return this.dataMode == 1 ? "Dev" : "Prod";
            },
        },

        methods: {
            profile: function () {
                this.$q.dialog({
                    component: CurrentUserEditModel,
                    parent: this,
                    actionLabel: 'Save',
                    index: 0,
                    modelId: this.userId,
                    modelObject: null,
                    actionTitle: '',
                    editMode: !this.isFederated
                }).onOk((payload) => {
                    this.$q.dialog({
                        title: 'Action',
                        message: 'Please relogin to update identity'
                    });
                });
            },

            editMFASettings: function () {
                this.$q.dialog({
                    component: MFASettingsEditModel,
                    parent: this,
                    index: 0,
                    modelId: this.userId,
                    modelObject: null,
                }).onOk((payload) => {
                    this.$q.dialog({
                        title: 'Action',
                        message: 'Please relogin to update identity'
                    });
                });
            },

            switchCustomer: async function (customerKey) {
                let response = await this.$http.post('/api/ui/customers/switch/' + customerKey);
                this.$processServerJsonResponse(response.body);
            },

            switchToProdMode: async function () {
                let response = await this.$http.post('/Application/SwitchToProdMode');
                this.$processServerJsonResponse(response.body);
            },

            switchToTestMode: async function () {
                let response = await this.$http.post('/Application/SwitchToTestMode');
                this.$processServerJsonResponse(response.body);
            },

            resetPassword: function () {
                window.location.href = '/Application/ResetPassword';
            },

            logout: function () {
                window.location.href = '/Application/Logout';
            },
        },

        mounted: async function () {
            try {
                this.$q.loading.show({
                    message: 'In progress...'
                });

                let response = await this.$http.get('/Application/CurrentUser');
                this.userId = response.body.userId;
                this.userName = response.body.userName;
                this.isAdmin = response.body.isAdmin;
                this.$userPermissions.isSystemAdministrator = response.body.isSystemAdministrator === true;
                this.isFederated = response.body.isFederated;
                this.customerName = response.body.customerName;
                this.dataMode = response.body.dataMode;

                this.isAnonymous = response.body.isAnonymous == true;
                this.showMenu = this.isAnonymous != true;

                if (this.showMenu == true) {
                    response = await this.$http.get('/Application/MainMenu');
                    this.menuItemGroups = response.body;

                    response = await this.$http.get('/api/ui/customers/getByUser');
                    this.availableCustomers = response.body;
                }
            }
            catch (ex) {
                this.$processServerJsonResponse(ex.body);
            }
            finally {
                this.$q.loading.hide();
            }
        }
    }
</script>
